@import '~style-sheet-helpers/core.less';

.detail-section {
  &:not(:last-child) {
    margin-bottom: 15px;
  }
}
